// extracted by mini-css-extract-plugin
export default {"root":"OfflineBanner_root__U7I0n","offline":"OfflineBanner_offline__ZCyxb","backOnline":"OfflineBanner_backOnline__iXEIF","dot":"OfflineBanner_dot__HMRe0"};